import { render, staticRenderFns } from "./CreateCertificate.vue?vue&type=template&id=6f32aaf9&"
import script from "./CreateCertificate.vue?vue&type=script&lang=ts&"
export * from "./CreateCertificate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports